module.exports = __webpack_public_path__ + "media/kick.0ef44e69.wav";